<template>
  <b-modal
    id="gnv-under-18-modal"
    v-model="isVisible"
    centered
    hide-header
    hide-header-close
    hide-footer
    :no-close-on-backdrop="false"
    :no-close-on-esc="true"
    content-class="gnv-flow-modal-content"
    body-class="gnv-flow-modal-body p-0"
  >
    <div class="gnv-flow-modal gnv-flow-modal--dark-theme">
      <div class="gnv-flow-modal__top-bar" />

      <div class="gnv-flow-modal__inner">
        <h4 class="gnv-flow-modal__title">
          {{ title }}
        </h4>

        <p class="gnv-flow-modal__message">
          {{ message }}
        </p>

        <div class="gnv-flow-modal__actions gnv-flow-modal__actions--single gnv-flow-modal__actions--stacked">
          <button
            type="button"
            class="gnv-flow-modal__btn gnv-flow-modal__btn--primary"
            :style="gnvModalPrimaryButtonStyle"
            @click="confirm"
          >
            {{ confirmButtonText }}
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import gnvModalMixin from '@/mixins/gnvModalMixin'

export default {
  name: 'GnvUnder18Modal',
  mixins: [gnvModalMixin],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
    title() {
      return this.gnvFlow.under18ModalTitle || this.$t('gnv.under18Title')
    },
    message() {
      return this.gnvFlow.under18Message || this.$t('gnv.under18Message')
    },
    confirmButtonText() {
      return this.gnvFlow.under18ConfirmButtonText || this.$t('common.understood')
    },
  },
  methods: {
    confirm() {
      this.$emit('confirm')
      this.isVisible = false
    },
  },
}
</script>
